import { Box, Flex, Text, Collapse, IconButton, Icon, Tooltip } from "@chakra-ui/react";
import { FaCheckCircle, FaChevronDown, FaChevronUp, FaEdit, FaEye, FaEyeSlash, FaLanguage, FaMinusCircle } from "react-icons/fa";
import { memo, useState } from "react";
import MenuItems from "./MenuItems";
import TranslationModal from "./TranslationModal";

const MenuSections = ({ sections, onEdit, onDeactivate }) => {
    const [openSections, setOpenSections] = useState({});
    const [translationSection, setTranslationSection] = useState(null);

    const toggleSection = (sectionId, event) => {
        if (event.target.closest(".edit-icon, .deactivate-icon, .translate-icon")) return;
        setOpenSections((prev) => ({
            ...prev,
            [sectionId]: !prev[sectionId],
        }));
    };

    return (
        <>
            {sections.length > 0 ? (
                sections.map((section) => (
                    <Box key={section.id} bg="white" borderRadius="xl" border="1px solid" borderColor="gray.100" boxShadow="card" p={4} mb={4}>
                        <Flex
                            justify="space-between"
                            align="center"
                            gap={3}
                            cursor="pointer"
                            onClick={(e) => toggleSection(section.id, e)}
                        >
                            <Box minW={0}>
                                <Flex align="center" gap={2}>
                                    <Text fontSize="lg" fontWeight="bold" color="brand.700">
                                        {section.name}
                                    </Text>
                                    <Tooltip label={section.isActive ? "Aktivno" : "Neaktivno"} fontSize="sm">
                                        <Box as="span" display={{ base: "none", md: "inline-block" }}>
                                            <Icon
                                                as={section.isActive ? FaCheckCircle : FaMinusCircle}
                                                color={section.isActive ? "green.400" : "gray.400"}
                                                boxSize={3.5}
                                                verticalAlign="middle"
                                            />
                                        </Box>
                                    </Tooltip>
                                </Flex>
                                <Text fontSize="sm" color="gray.500">{section.header}</Text>
                            </Box>
                            <Flex flexShrink={0}>
                                <IconButton
                                    icon={<FaEdit />}
                                    size="sm"
                                    mr={2}
                                    className="edit-icon"
                                    onClick={() => onEdit("section", section)}
                                />
                                <IconButton
                                    icon={section.isActive ? <FaEyeSlash /> : <FaEye />}
                                    size="sm"
                                    mr={2}
                                    className="deactivate-icon"
                                    aria-label={section.isActive ? "Deactivate section" : "Activate section"}
                                    onClick={() => onDeactivate("section", section)}
                                />
                                <IconButton
                                    icon={<FaLanguage />}
                                    size="sm"
                                    mr={2}
                                    className="translate-icon"
                                    aria-label="Translate section"
                                    onClick={() => setTranslationSection(section)}
                                />
                                <IconButton
                                    icon={openSections[section.id] ? <FaChevronUp /> : <FaChevronDown />}
                                    size="sm"
                                />
                            </Flex>
                        </Flex>

                        <Collapse in={openSections[section.id]} animateOpacity>
                            <Text fontSize="sm" mt={2} mb={3} color="gray.600">{section.description}</Text>

                            <MenuItems
                                items={section.items}
                                onEdit={onEdit}
                                onDeactivate={onDeactivate}
                                sectionId={section.id}
                            />
                        </Collapse>
                    </Box>
                ))
            ) : (
                <Text align="center">No sections available.</Text>
            )}

            {translationSection && (
                <TranslationModal
                    entityType="section"
                    entity={translationSection}
                    onClose={() => setTranslationSection(null)}
                />
            )}
        </>
    );
};

export default memo(MenuSections);
